export default {
  getMessageConfirmation () {
    return {
      cancel: 'Cancelar',
      label: 'Remover',
      title: 'Confirmar Remoção',
      message: 'Deseja remover a graduação <strong>' + this.currentEntity.label + '</strong>?'
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/curriculum/graduations/index/resources/computed.js